import React from "react";
import "./ProfileMembers.css";
import SSrajampouliHero from "../../../Images/SSrajamouli.jpg";
import ChetanSharma from "../../../../assests/Chetan-Sharma.webp";

function ProfileMembers() {
    return (
        <>

            <div className="sunilBabu">
                  <div className="SunilbabuImage">
      <img src={ChetanSharma} alt="Chetan sharma isbc" />
        </div>
                <div className="aboutSunilBabu">
                    <div className="sunilBabuText">
                        <p>
                            A legend on the field and a leader off it, Chetan Sharma's vision for sports extends beyond his historic hat-trick. After a remarkable playing career, Sharma's dedication to Indian cricket continues as the Ex-Chairman of the BCCI Senior Selection Committee. His passion for nurturing talent is fueled by his own journey, inspiring him to champion the future of Indian sports.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProfileMembers;
